import { render, staticRenderFns } from "./twlhc.vue?vue&type=template&id=58132d48&scoped=true"
import script from "./twlhc.vue?vue&type=script&lang=js"
export * from "./twlhc.vue?vue&type=script&lang=js"
import style0 from "./twlhc.vue?vue&type=style&index=0&id=58132d48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58132d48",
  null
  
)

export default component.exports